import { render, staticRenderFns } from "./OpenPatientInPhysitrackButton.vue?vue&type=template&id=0d383809&"
import script from "./OpenPatientInPhysitrackButton.vue?vue&type=script&lang=js&"
export * from "./OpenPatientInPhysitrackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports